module.exports = __webpack_public_path__ + "img/ig.a8014de8.png";